import { mdiArrowRight } from '@mdi/js'
import { useIntl } from 'react-intl'
import { generatePath, useHistory } from 'react-router-dom'

import { CommonLinkButton } from 'components/Button'
import StatusIndicator from '../StatusIndicator'
import { homeDevicesMessages } from '../messages'
import type { Devices } from '../types'
import {
  HomeDevicesCard,
  HomeDevicesCardInfoName,
  HomeDevicesCardRow,
  HomeDevicesCardTitle,
  HomeDevicesFlexRow,
  StyledIcon,
  HomeDevicesCardInfoValue,
} from './styles'
import { useHomeRouteParams } from 'features/home/hooks'
import { useAppSelector } from 'app/hooks'
import { currentRootDomainIdSelector } from 'features/rootDomains/selectors'
import ROUTES from 'app/routes'
import { useCallback } from 'react'

interface MobileDevicesComponentProps {
  values: Record<string, any>
  original: Devices
}

export function MobileDevicesComponent(props: MobileDevicesComponentProps) {
  const device = props.values as Devices
  const originalValues = props.original as Devices

  const { formatMessage } = useIntl()
  const history = useHistory()
  const { homeId } = useHomeRouteParams()

  const currentRootId = useAppSelector(currentRootDomainIdSelector)
  const handleClick = useCallback(
    (id: string) => () => {
      if (currentRootId) {
        const devicePath = generatePath(ROUTES.homeDevice, {
          id,
          homeId,
          rootDomainId: currentRootId,
        })
        return history.push(devicePath)
      }
    },
    [homeId, history, currentRootId]
  )

  return (
    <HomeDevicesCard
      onClick={handleClick(
        originalValues.statusPath ||
          originalValues.id ||
          originalValues.deviceName!
      )}
    >
      <HomeDevicesCardRow>
        <HomeDevicesFlexRow>
          <StatusIndicator status={device.status} />
          <HomeDevicesCardTitle>{device.deviceName}</HomeDevicesCardTitle>
        </HomeDevicesFlexRow>
        <CommonLinkButton>
          <StyledIcon path={mdiArrowRight} size={1} />
        </CommonLinkButton>
      </HomeDevicesCardRow>
      <HomeDevicesCardRow>
        <HomeDevicesCardInfoName>
          {formatMessage(homeDevicesMessages.deviceTypeColumn)}
        </HomeDevicesCardInfoName>
        <HomeDevicesCardInfoValue>{device.deviceType}</HomeDevicesCardInfoValue>
      </HomeDevicesCardRow>
      <HomeDevicesCardRow>
        <HomeDevicesCardInfoName>
          {formatMessage(homeDevicesMessages.manufacturerColumn)}
        </HomeDevicesCardInfoName>
        <HomeDevicesCardInfoValue>
          {originalValues.deviceManufacturer || '-'}
        </HomeDevicesCardInfoValue>
      </HomeDevicesCardRow>
      <HomeDevicesCardRow>
        <HomeDevicesCardInfoName>
          {formatMessage(homeDevicesMessages.roomColumn)}
        </HomeDevicesCardInfoName>
        <HomeDevicesCardInfoValue>{device.room}</HomeDevicesCardInfoValue>
      </HomeDevicesCardRow>
      <HomeDevicesCardRow>
        <HomeDevicesCardInfoName>
          {formatMessage(homeDevicesMessages.ipAddressColumn)}
        </HomeDevicesCardInfoName>
        <HomeDevicesCardInfoValue>{device.ipAddress}</HomeDevicesCardInfoValue>
      </HomeDevicesCardRow>
    </HomeDevicesCard>
  )
}
